import React from "react";
import { Five } from "./Chart.config";
import ShreeDayTable from "./ShreeDayTable";

const ShreeDay = ({ chartData }) => {
    return <ShreeDayTable staticData={Five} chartData={chartData} />;
};

export default ShreeDay;
